import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import {
  Select, SelectTrigger, SelectContent, SelectItem, SelectValue,
} from "../ui/select";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { Button } from "../ui/button";

export default function ReportInfo({ form, set, orgs }) {
  return (
    <div className="space-y-6 max-w-3xl">
      <div className="p-6 rounded-2xl border border-border bg-card">
        <h3 className="font-display text-xl font-semibold mb-5">Kuruluş & Rapor</h3>
        <div className="space-y-5">
          <div>
            <Label className="text-sm font-medium mb-1.5 block">Tesis *</Label>
            <div className="flex gap-2">
              <Select value={form.organization_id} onValueChange={(v) => set("organization_id", v)}>
                <SelectTrigger data-testid="select-org"><SelectValue placeholder="Tesis seçin" /></SelectTrigger>
                <SelectContent>
                  {orgs.map((o) => (
                    <SelectItem key={o.id} value={o.id}>{o.name}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
              <Link to="/organizations/new"><Button variant="outline" className="gap-1"><Plus className="size-4" /> Yeni</Button></Link>
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <Field label="Rapor Yılı *">
              <Input data-testid="rep-year" type="number" value={form.year} onChange={(e) => set("year", e.target.value)} />
            </Field>
            <Field label="Temel Yıl">
              <Input type="number" value={form.base_year || ""} onChange={(e) => set("base_year", e.target.value)} />
            </Field>
            <Field label="Rapor Tarihi">
              <Input type="date" value={form.report_date} onChange={(e) => set("report_date", e.target.value)} />
            </Field>
            <Field label="Sıklık">
              <Input value={form.frequency} onChange={(e) => set("frequency", e.target.value)} placeholder="12 aylık" />
            </Field>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Field label="Dönem Başlangıç">
              <Input type="date" value={form.period_start} onChange={(e) => set("period_start", e.target.value)} />
            </Field>
            <Field label="Dönem Bitiş">
              <Input type="date" value={form.period_end} onChange={(e) => set("period_end", e.target.value)} />
            </Field>
          </div>
        </div>
      </div>

      <div className="p-6 rounded-2xl border border-border bg-card">
        <h3 className="font-display text-xl font-semibold mb-5">Rapordan Sorumlu Kişi</h3>
        <div className="space-y-5">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Field label="Adı Soyadı">
              <Input data-testid="prep-name" value={form.prepared_by_name} onChange={(e) => set("prepared_by_name", e.target.value)} placeholder="Ad Soyad" />
            </Field>
            <Field label="Unvan">
              <Input value={form.prepared_by_title} onChange={(e) => set("prepared_by_title", e.target.value)} placeholder="Genel Müdür, vs." />
            </Field>
          </div>
          <Field label="E-posta">
            <Input type="email" value={form.prepared_by_email} onChange={(e) => set("prepared_by_email", e.target.value)} placeholder="email@otel.com" />
          </Field>
        </div>
      </div>

      <div className="p-6 rounded-2xl border border-border bg-card">
        <h3 className="font-display text-xl font-semibold mb-5">Ek Notlar</h3>
        <Textarea rows={4} value={form.notes} onChange={(e) => set("notes", e.target.value)}
                  placeholder="Bu rapor hakkında özel notlar..." />
      </div>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <div>
      <Label className="text-sm font-medium mb-1.5 block">{label}</Label>
      {children}
    </div>
  );
}
